const initialState = {
    data: null,
}
export const stats2Reducer = (state = initialState, action) => {
    switch (action.type) {
        case 'GETSTATSGROUPDATE_SUCCESS':
            return {
                ...state,
                data: action.payload,
            };
        case 'GETSTATSGROUPDATE_FAILURE':
            return {
                ...state,
                error: action.payload
            };
        default:
            return state;
    }
}

export default stats2Reducer; 